module.exports = __webpack_public_path__ + "static/media/IMG_3636-min.7bac4461.JPG";